import EventStep from "../EventStep";
import {
  DISPARO_EVENTO,
  CLIENTE_NOTIFICADO,
  APROVACAO,
  CONFIRMACAO,
  PEDIDO_ATENDIDO,
  OCORRENCIA_ENCERRADA,
} from "../Enum/EventActionStep";
import {
  NOT_AVAILABLE,
  WAITING_APPROVAL_EMISSION,
  WAITING_CONFIRMATION_NO_EMISSION,
  BusinessEventStatus,
} from "../EventStatus";

const BACK_TO_EPOCH = -8640000000000000;

const PASSOS_COMUNS: EventStep[] = [
  {
    etapa_evento: DISPARO_EVENTO,
    status_cobranca: NOT_AVAILABLE,
    comentario: undefined,
    aprovador: undefined,
    created_at: "",
    updated_at: "",
    created_at_formatted: "",
    updated_at_formatted: "",
    lista_destinatarios: undefined,
  },
  {
    etapa_evento: CLIENTE_NOTIFICADO,
    status_cobranca: NOT_AVAILABLE,
    comentario: undefined,
    aprovador: undefined,
    created_at: "",
    updated_at: "",
    created_at_formatted: "",
    updated_at_formatted: "",
    lista_destinatarios: undefined,
  },
  {
    etapa_evento: OCORRENCIA_ENCERRADA,
    status_cobranca: NOT_AVAILABLE,
    comentario: undefined,
    aprovador: undefined,
    created_at: "",
    updated_at: "",
    created_at_formatted: "",
    updated_at_formatted: "",
    lista_destinatarios: undefined,
  },
];

const TEMPLATE_APROVACAO: EventStep = {
  etapa_evento: APROVACAO,
  status_cobranca: WAITING_APPROVAL_EMISSION,
  comentario: undefined,
  aprovador: undefined,
  created_at: "",
  updated_at: "",
  created_at_formatted: "",
  updated_at_formatted: "",
  lista_destinatarios: undefined,
};

const TEMPLATE_CONFIRMACAO: EventStep = {
  etapa_evento: CONFIRMACAO,
  status_cobranca: WAITING_CONFIRMATION_NO_EMISSION,
  comentario: undefined,
  aprovador: undefined,
  created_at: "",
  updated_at: "",
  created_at_formatted: "",
  updated_at_formatted: "",
  lista_destinatarios: undefined,
};

const TEMPLATE_PEDIDO_ATENDIDO: EventStep = {
  etapa_evento: PEDIDO_ATENDIDO,
  status_cobranca: NOT_AVAILABLE,
  comentario: undefined,
  aprovador: undefined,
  created_at: "",
  updated_at: "",
  created_at_formatted: "",
  updated_at_formatted: "",
  lista_destinatarios: undefined,
};

export const TEMPLATE_FLUXOS_PRAGAS: EventStep[] = [
  ...PASSOS_COMUNS,
  TEMPLATE_APROVACAO,
  TEMPLATE_CONFIRMACAO,
].sort((x, y) => x.etapa_evento - y.etapa_evento);

export const TEMPLATE_PASSOS_FLUXO_6: EventStep[] = [
  ...PASSOS_COMUNS,
  TEMPLATE_PEDIDO_ATENDIDO,
].sort((x, y) => x.etapa_evento - y.etapa_evento);
